// import RoutingActions from '../../../actions/RoutingActions';
// import GuestListActions from '../../../actions/GuestListActions';

// import UserStore from '../../stores/UserStore';

// import GuestListStore from '../../../stores/GuestListStore';

// import PosProfile from './PosProfile.react';
import EditNotes from './EditNotes.react';
import PosCartActions from '../../../actions/PosCartActions';

class PosNotes extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            edit : false
        };

        // this.onUserStoreChange = this.onUserStoreChange.bind(this);
        // this.onRoutingStoreChange = this.onRoutingStoreChange.bind(this);
    }

    render() {
    	var guest = this.props.guest;

    	if (!guest)
            return null;

        var notes = guest.notes.replace(/\n/g, "<br />");
        var creditNote = guest.CreditNote.replace(/\n/g, "<br />");
        var conditions = guest.Conditions.replace(/\n/g, "<br />");

        return (
            <div className='pos-sidebar__content'>
                <table className='sidebar-notes'>
                    <tbody>
                        { notes.length === 0 && creditNote.length === 0 && conditions.length === 0 &&
                            <tr>
                                <td>
                                    No Patient Notes
                                </td>
                            </tr>
                        }

                        <tr>
                            <td
                                onClick={() => { this.setState({ edit : true }) }}>

                                Notes:
                                <div dangerouslySetInnerHTML={{ __html: notes }} />
                            </td>
                        </tr>

                        { creditNote.length > 0 &&
                            <tr>
                                <td>
                                    Vouchers and referrals:
                                    <div dangerouslySetInnerHTML={{ __html: creditNote }} />
                                </td>
                            </tr>
                        }
                        { conditions.length > 0 &&
                            <tr>
                                <td>
                                    Conditions:
                                    <div dangerouslySetInnerHTML={{ __html: conditions }} />
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>

                { this.state.edit &&
                    <EditNotes
                        notes={guest.notes}
                        guest={guest}
                        onClose={() => { 
                            PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
                            this.setState({ edit : false }); 
                        }} />
                }
	        </div>
        );
    }
}

export default PosNotes;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/PosNotes.react.jsx